export enum ModalId {
  CallConfirmation = 'callConfirmation',
  CallClassification = 'callClassification',
  SimpleConfirmationModal = 'simpleConfirmationModal',
  ResetAccountModal = 'resetAccountModal',
  // Add more modal IDs as needed
}
